// Function to get logo - using text-based logo for better thermal printer compatibility
const getLogo = () => {
  // Using ASCII art logo for better thermal printer compatibility
  return '🍖 کبابی مارو 🍖'
}

export const generateOrderPrintContent = (order, table) => {
  const itemsHtml = order.orderItems?.map((item, index) => 
    '<tr>' +
      '<td class="col-1">' + (index + 1) + '</td>' +
      '<td class="col-2" style="word-wrap: break-word;">' + (item.menuItemName || '') + '</td>' +
      '<td class="col-3">' + (item.quantity || 0) + '</td>' +
      '<td class="col-4">' + new Intl.NumberFormat('fa-IR').format(item.totalPrice || 0) + '</td>' +
    '</tr>'
  ).join('') || ''
  
  const notesHtml = order.notes ? 
    '<div style="margin-top: 8px; padding: 6px; border: 1px solid #000; background: #f9f9f9; font-size: 10px;">' +
      '<div style="font-weight: bold; margin-bottom: 3px;">یادداشت:</div>' +
      '<div>' + (order.notes || '') + '</div>' +
    '</div>' 
    : ''

  // Check if this is a pickup order
  const isPickupOrder = order.isPickup
  
  // Delivery information for pickup orders
  const deliveryInfoHtml = isPickupOrder ? 
    '<div style="margin: 8px 0; padding: 6px; border: 1px solid #000; background: #f9f9f9; font-size: 8px;">' +
      '<div style="font-weight: bold; margin-bottom: 6px; text-align: center; border-bottom: 1px solid #000; padding-bottom: 3px;">تحویل</div>' +
      '<div style="margin-bottom: 3px;"><strong>نوع:</strong> تحویل</div>' +
      '<div style="margin-bottom: 3px;"><strong>شماره:</strong> #' + (order.id || '') + '</div>' +
      (order.deliveryAddress ? 
        '<div style="margin-bottom: 3px;"><strong>آدرس:</strong> ' + (order.deliveryAddress || '') + '</div>' 
        : '') +
      (order.deliveryFee > 0 ? 
        '<div style="margin-bottom: 3px;"><strong>هزینه:</strong> ' + new Intl.NumberFormat('fa-IR').format(order.deliveryFee || 0) + '</div>' 
        : '') +
    '</div>' 
    : ''

  // Calculate totals with tax information
  const subtotal = order.subtotalAmount || 0
  const taxAmount = order.taxAmount || 0
  const taxPercentage = order.taxPercentage || 0
  const deliveryFee = isPickupOrder ? (order.deliveryFee || 0) : 0
  const totalAmount = order.totalAmount || (subtotal + taxAmount + deliveryFee)

  // Total rows for pickup orders
  const totalRowsHtml = isPickupOrder ? 
    '<tr style="background: #f0f0f0; font-size: 10px;">' +
      '<td colspan="3" class="col-1" style="border-right: none;">مجموع:</td>' +
      '<td class="col-4" style="border-left: none;">' + new Intl.NumberFormat('fa-IR').format(subtotal) + '</td>' +
    '</tr>' +
    (taxAmount > 0 ? 
      '<tr style="background: #f0f0f0; font-size: 10px;">' +
        '<td colspan="3" class="col-1" style="border-right: none;">مالیات (' + taxPercentage + '%):</td>' +
        '<td class="col-4" style="border-left: none;">' + new Intl.NumberFormat('fa-IR').format(taxAmount) + '</td>' +
      '</tr>' 
      : '') +
    (deliveryFee > 0 ? 
      '<tr style="background: #e0e0e0; font-size: 10px;">' +
        '<td colspan="3" class="col-1" style="border-right: none;">تحویل:</td>' +
        '<td class="col-4" style="border-left: none;">' + new Intl.NumberFormat('fa-IR').format(deliveryFee) + '</td>' +
      '</tr>' 
      : '') +
    '<tr class="total-row" style="font-size: 11px; font-weight: bold;">' +
      '<td colspan="3" class="col-1">کل:</td>' +
      '<td class="col-4">' + new Intl.NumberFormat('fa-IR').format(totalAmount) + '</td>' +
    '</tr>'
   : 
   '<tr style="background: #f0f0f0; font-size: 10px;">' +
     '<td colspan="3" class="col-1" style="border-right: none;">مجموع:</td>' +
     '<td class="col-4" style="border-left: none;">' + new Intl.NumberFormat('fa-IR').format(subtotal) + '</td>' +
   '</tr>' +
   (taxAmount > 0 ? 
     '<tr style="background: #f0f0f0; font-size: 10px;">' +
       '<td colspan="3" class="col-1" style="border-right: none;">مالیات (' + taxPercentage + '%):</td>' +
       '<td class="col-4" style="border-left: none;">' + new Intl.NumberFormat('fa-IR').format(taxAmount) + '</td>' +
     '</tr>' 
     : '') +
   '<tr class="total-row" style="font-size: 11px; font-weight: bold;">' +
     '<td colspan="3" class="col-1">کل:</td>' +
     '<td class="col-4">' + new Intl.NumberFormat('fa-IR').format(totalAmount) + '</td>' +
   '</tr>'
  
  return [
    '<!DOCTYPE html>',
    '<html dir="rtl" lang="fa">',
    '<head>',
      '<meta charset="UTF-8">',
      '<title>' + (isPickupOrder ? 'سفارش تحویل' : 'سفارش ' + (table?.name || '')) + '</title>',
      '<style>',
        '@media print { @page { margin: 0.5cm; size: 80mm auto; } }',
        'body { font-family: "Tahoma", "Arial", sans-serif; font-size: 12px; color: #000; direction: rtl; margin: 0; padding: 0; width: 80mm; }',
        'table { width: 100%; border-collapse: collapse; margin: 3px 0; font-size: 9px; }',
        'th, td { border: 1px solid #000; padding: 2px; text-align: right; }',
        'th { background: #f0f0f0; font-weight: bold; font-size: 9px; }',
        '.col-1 { width: 10%; }',
        '.col-2 { width: 28%; }',
        '.col-3 { width: 20%; }',
        '.col-4 { width: 42%; }',
        '.header { text-align: center; border-bottom: 1px solid #000; padding-bottom: 8px; margin-bottom: 8px; }',
        '.logo { font-size: 20px; margin-bottom: 3px; }',
        '.order-info { display: grid; grid-template-columns: 1fr 1fr; gap: 3px; margin-bottom: 8px; padding: 4px; border: 1px solid #000; background: #f9f9f9; font-size: 8px; }',
        '.order-info div { text-align: center; }',
        '.total-row { background: #f0f0f0; font-weight: bold; }',
        '.footer { margin-top: 15px; text-align: center; font-size: 8px; border-top: 1px solid #000; padding-top: 5px; }',
        '.pickup-header { background: #f0f0f0; color: #000; padding: 6px; border-radius: 4px; margin-bottom: 8px; border: 1px solid #000; text-align: center; }',
        '.pickup-header h1 { margin: 0; font-size: 12px; }',
        '.pickup-header p { margin: 2px 0 0 0; font-size: 8px; }',
        '.divider { border-top: 1px dashed #000; margin: 10px 0; }',
      '</style>',
    '</head>',
    '<body>',
      isPickupOrder ? 
        '<div class="pickup-header">' +
          '<h1>سفارش تحویل</h1>' +
        '</div>'
        :
        '<div class="header">' +
          '<div style="font-size: 14px; font-weight: bold; margin-bottom: 3px; text-align: center;">' + getLogo() + '</div>' +
          '<div style="font-size: 8px;">فاکتور سفارش</div>' +
        '</div>',
      '<div class="order-info">' +
        '<div><div style="font-weight: bold;">شماره</div><div>' + (order.id || '') + '</div></div>' +
        '<div><div style="font-weight: bold;">' + (isPickupOrder ? 'نوع' : 'میز') + '</div><div>' + (isPickupOrder ? 'تحویل' : (table?.name || '')) + '</div></div>' +
        '<div><div style="font-weight: bold;">' + (isPickupOrder ? 'وضعیت' : 'بخش') + '</div><div>' + (isPickupOrder ? 'انتظار' : (table?.sectionName || '')) + '</div></div>' +
        '<div><div style="font-weight: bold;">تاریخ</div><div>' + new Date(order.createdAt).toLocaleDateString('fa-IR') + '</div></div>' +
        '<div><div style="font-weight: bold;">ساعت</div><div>' + new Date(order.createdAt).toLocaleTimeString('fa-IR', { hour: '2-digit', minute: '2-digit' }) + '</div></div>' +
      '</div>',
      deliveryInfoHtml,
      '<table>',
        '<thead>',
          '<tr>',
            '<th class="col-1">ردیف</th>',
            '<th class="col-2">نام محصول</th>',
            '<th class="col-3">تعداد</th>',
            '<th class="col-4">کل</th>',
          '</tr>',
        '</thead>',
        '<tbody>',
          itemsHtml,
          totalRowsHtml,
        '</tbody>',
      '</table>',
      notesHtml,
      '<div class="divider"></div>',
      '<div class="footer">' +
        '<div>با تشکر از انتخاب شما</div>' +
        '<div>کبابی مارو</div>' +
        '<div>تاریخ چاپ: ' + new Date().toLocaleDateString('fa-IR') + ' - ' + new Date().toLocaleTimeString('fa-IR', { hour: '2-digit', minute: '2-digit' }) + '</div>' +
      '</div>',
      '<script>window.onload = function() { window.print(); window.onafterprint = function() { window.close(); }; };</script>',
    '</body>',
    '</html>'
  ].join('')
}

export const printOrder = (order, table) => {
  const printWindow = window.open('', '_blank', 'width=320,height=600')
  const printContent = generateOrderPrintContent(order, table)
  printWindow.document.write(printContent)
  printWindow.document.close()
}
